import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/gameknight/Home.vue";
import DetailPage from "@/components/gameknight/DetailPage.vue"
import Profile from "@/components/gameknight/Profile.vue"
import Subcategory from "@/components/gameknight/Subcategory.vue"
import HotPicks from "@/components/gameknight/HotPicks.vue"
import Popular from "@/components/gameknight/Popular.vue"
import Login from "@/components/authentication/gameknight/Login.vue"
import PrivacyPolicy from "../components/gameknight/PrivacyPolicy.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  hash: false,
  history: true,
  routes: [
    {
      path: "/home",
      name: "Home",
      component: Home,
      children: [
        {
          path: "/home/:token"
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      children: [
        {
          path: "/logout"
        }
      ]
    },
    {
      path: "/detail/:id",
      name: "DetailPage",
      component: DetailPage,
      children: [
        {
          path: "/detail/:id/:token"
        }
      ]
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      children: [
          {
          path: "/profile/:token"
          }
      ]
    },
    {
      path: "/hotpicks",
      name: "HotPicks",
      component: HotPicks,
      children: [
        {
          path: "/hotpicks/:token"
        }
      ]
    },
    {
      path: "/popular",
      name: "Popular",
      component: Popular,
      children: [
        {
          path: "/popular/:token"
        }
      ]
    },
    {
      path: "/privacy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
      children: [
        {
          path: "/privacy/:token"
        }
      ]
    },
    {
      path: "/subcategory/:subcategory",
      name: "Subcategory",
      component: Subcategory,
      children: [
          {
          path: "/subcategory/:subcategory/:token"
          }
      ]
    },
    {
      path: '/:token',
      name: 'Home',
      component: Home
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/gameknight.js